<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
    <defs>
      <linearGradient id="a" x1="62.07%" x2="0%" y1="50%" y2="-11.302%">
        <stop class="first-stop" offset="0%" />
        <stop class="second-stop" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <circle cx="13.5" cy="13.5" r="13.5" fill="url(#a)" />
      <path
        fill="#FFF"
        d="M12.281 18.948a.749.749 0 0 1-.556-.245l-3.468-3.888a.928.928 0 0 1-.027-1.253.759.759 0 0 1 1.152-.029l2.542 1.973c.146.144.37.115.49-.057l6.023-8.094c.265-.39.781-.476 1.14-.173.357.288.436.85.158 1.239L12.93 18.588a.795.795 0 0 1-.582.345c-.027.015-.04.015-.067.015z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'GradientCheck'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

stop {
  &.first-stop {
    stop-color: $tertiary;
  }

  &.second-stop {
    stop-color: $primary;
  }
}
</style>
